<template>
  <el-dialog :visible.sync="visible" width="650px" :show-close="false" :close-on-click-modal="false"
    custom-class="add-parking-space-dialog" @close="closeDialog">
    <div class="dialog-header">
      <span class="dialog-title">{{ $t('addParkingSpace.title') }}</span>
      <i class="el-icon-close dialog-close" @click="visible = false"></i>
    </div>

    <div class="dialog-body">
      <el-form :model="form" ref="form">
        <div class="form-row form-row-community">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>小区</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-select v-model="form.communityId" placeholder="请选择" class="form-select" @change="handleCommunityChange">
              <el-option v-for="item in communities" :key="item.communityId" :label="item.name"
                :value="item.communityId"></el-option>
            </el-select>
          </div>
        </div>

        <div class="form-row form-row-num">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>{{ $t('addParkingSpace.parkingSpaceNum') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-input v-model="form.num" :placeholder="$t('addParkingSpace.parkingSpaceNumPlaceholder')"
              class="form-input"></el-input>
          </div>
        </div>

        <div class="form-row form-row-parking">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>{{ $t('addParkingSpace.parkingLot') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-select v-model="form.paId" :placeholder="$t('addParkingSpace.parkingLotPlaceholder')"
              class="form-select">
              <el-option v-for="item in parkingAreas" :key="item.paId" :label="item.num"
                :value="item.paId"></el-option>
            </el-select>
          </div>
        </div>

        <div class="form-row form-row-type">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>{{ $t('addParkingSpace.parkingSpaceType') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-select v-model="form.parkingType" :placeholder="$t('addParkingSpace.parkingSpaceTypePlaceholder')"
              class="form-select">
              <el-option v-for="item in parkingTypes" :key="item.statusCd" :label="item.name"
                :value="item.statusCd"></el-option>
            </el-select>
          </div>
        </div>

        <div class="form-row form-row-area">
          <div class="form-label required">
            <span class="required-mark">*</span>
            <span>{{ $t('addParkingSpace.area') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-input v-model="form.area" type="number" :placeholder="$t('addParkingSpace.areaPlaceholder')"
              class="form-input"></el-input>
          </div>
        </div>

        <div class="form-row form-row-remark">
          <div class="form-label">
            <span>{{ $t('addParkingSpace.remark') }}</span>
            <span class="colon">:</span>
          </div>
          <div class="form-control">
            <el-input v-model="form.remark" type="textarea" :placeholder="$t('addParkingSpace.remarkPlaceholder')"
              class="form-input"></el-input>
          </div>
        </div>
      </el-form>
    </div>

    <div class="dialog-footer">
      <el-button class="cancel-btn" @click="visible = false">{{ $t('addParkingSpace.cancel') }}</el-button>
      <el-button class="confirm-btn" @click="saveParkingSpace" :loading="saving">
        {{ $t('addParkingSpace.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveParkingSpace } from '@/api/car/listParkingSpaceApi'
import { listParkingAreas } from '@/api/car/listParkingSpaceApi'
import { getDict } from '@/api/community/communityApi'
import { getEffectiveCommunityId } from '@/api/community/communityApi'
import { listCommunitys } from '@/api/community/communityManageApi'

export default {
  name: 'AddParkingSpace',
  data() {
    return {
      visible: false,
      saving: false,
      form: {
        num: '',
        paId: '',
        parkingType: '1',
        area: '1',
        remark: '',
        communityId: getEffectiveCommunityId()
      },
      parkingTypes: [],
      parkingAreas: [],
      communities: []
    }
  },
  methods: {
    open() {
      this.visible = true
      this.loadParkingTypes()
      this.loadParkingAreas()
      this.loadCommunities()
    },

    async loadCommunities() {
      try {
        const params = {
          page: 1,
          row: 1000
        }
        const res = await listCommunitys(params)
        this.communities = (res.communitys || []).filter(item => getEffectiveCommunityId(item.communityId))
      } catch (error) {
        console.error('load communities error:', error)
      }
    },

    async loadParkingTypes() {
      try {
        const data = await getDict('parking_space', 'parking_type')
        this.parkingTypes = data.filter(item => item.statusCd !== '4')
      } catch (error) {
        this.$message.error(this.$t('common.loadDictError'))
      }
    },

    async loadParkingAreas() {
      try {
        const params = {
          page: 1,
          row: 50,
          communityId: getEffectiveCommunityId(this.form.communityId)
        }
        const res = await listParkingAreas(params)
        this.parkingAreas = res.parkingAreas
      } catch (error) {
        this.$message.error(this.$t('common.loadError'))
      }
    },

    handleCommunityChange() {
      this.form.paId = ''
      this.loadParkingAreas()
    },

    async saveParkingSpace() {
      if (!this.form.communityId) {
        this.$message.error('请选择小区')
        return
      }
      if (!this.form.num) {
        this.$message.error('请输入车位编码')
        return
      }
      if (!this.form.paId) {
        this.$message.error('请选择停车场')
        return
      }
      if (!this.form.parkingType) {
        this.$message.error('请选择车位类型')
        return
      }
      if (!this.form.area) {
        this.$message.error('请输入面积')
        return
      }

      try {
        this.saving = true
        const res = await saveParkingSpace(this.form)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.$emit('success')
          this.visible = false
        } else {
          this.$message.error(res.msg || this.$t('common.saveError'))
        }
      } catch (error) {
        console.error('save failed:', error)
        this.$message.error(this.$t('common.saveError'))
      } finally {
        this.saving = false
      }
    },

    closeDialog() {
      this.$refs.form.resetFields()
      this.form = {
        num: '',
        paId: '',
        parkingType: '1',
        area: '1',
        remark: '',
        communityId: getEffectiveCommunityId()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .add-parking-space-dialog {
    border-radius: 12px;
    overflow: hidden;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 66px;
    padding: 0 24px;
    box-sizing: border-box;
    background: #EBF2FA;
    border-bottom: 1px solid #DCE6F5;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .dialog-title {
      font-size: 16px;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 600;
      color: #1D2129;
    }

    .dialog-close {
      font-size: 16px;
      color: #8C9BB4;
      cursor: pointer;

      &:hover {
        color: #1D2129;
      }
    }
  }

  .dialog-body {
    padding: 24px 0 0;

    .form-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      box-sizing: border-box;

      &:last-child {
        margin-bottom: 0;
      }

      .form-label {
        text-align: right;
        padding-top: 9px;
        flex-shrink: 0;
        font-size: 14px;
        font-family: 'PingFang SC', sans-serif;
        font-weight: 500;
        color: #1D2129;
        white-space: nowrap;

        .required-mark {
          color: #FB2C36;
          margin-right: 2px;
        }

        .colon {
          color: #000000;
          margin-left: 2px;
        }
      }

      .form-control {
        width: 516px;
        flex-shrink: 0;

        .form-input,
        .form-select {
          width: 100%;

          ::v-deep .el-input__inner {
            border-radius: 10px;
            border: 1px solid #DCE6F5;
            background: #FFFFFF;
            font-family: 'Inter', 'PingFang SC', sans-serif;
            font-size: 14px;
            color: #1D2129;
            height: 38px;
            line-height: 38px;

            &::placeholder {
              color: #8C9BB4;
            }
          }
        }
      }
    }

    .form-row-community {
      padding-left: 52px;
      .form-label { width: 58px; }
    }

    .form-row-num {
      padding-left: 24px;
      .form-label { width: 86px; }
    }

    .form-row-parking {
      padding-left: 38px;
      .form-label { width: 72px; }
    }

    .form-row-type {
      padding-left: 24px;
      .form-label { width: 86px; }
    }

    .form-row-area {
      padding-left: 52px;
      .form-label { width: 58px; }
    }

    .form-row-remark {
      padding-left: 64px;
      .form-label { width: 46px; }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 0 24px 28px;

    .cancel-btn {
      width: 98px;
      height: 38px;
      border-radius: 10px;
      border: 1px solid #0E76FF;
      background: #FFFFFF;
      color: #0E76FF;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;

      &:hover {
        background: #E8F3FF;
      }
    }

    .confirm-btn {
      width: 98px;
      height: 38px;
      border-radius: 10px;
      border: none;
      background: #0E76FF;
      color: #FFFFFF;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 500;
      font-size: 14px;
      padding: 0;

      &:hover {
        background: #1C99FF;
      }
    }
  }
</style>
